(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gl-header').forEach(function (header) {
    var searchToggle = header.querySelector('.gl-search-toggle');
    var searchPanel = header.querySelector('.gl-header__search');
    var menuToggle = header.querySelector('.gl-menu-toggle');
    var nav = header.querySelector('.gl-header__nav');
    var cartCount = header.querySelector('[data-cart-count]');

    // Sticky shadow on scroll
    if (header.dataset.sticky === 'true') {
      window.addEventListener('scroll', function () {
        header.classList.toggle('is-sticky', window.scrollY > 20);
      });
    }

    // ---------- Search ----------
    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.setAttribute('hidden', '');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    }

    function openSearch() {
      if (!searchPanel) return;
      searchPanel.removeAttribute('hidden');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
      var input = searchPanel.querySelector('input');
      if (input) input.focus();
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchToggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    }

    // ---------- Mobile menu ----------
    function closeMenu() {
      if (nav) nav.classList.remove('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        var isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
        if (nav) nav.classList.toggle('is-open', !isOpen);
        menuToggle.setAttribute('aria-expanded', String(!isOpen));
      });
    }

    // Close search/menu on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeSearch();
        closeMenu();
      }
    });

    // Close menu when clicking a nav link (mobile)
    if (nav) {
      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          if (window.innerWidth <= 899) {
            closeMenu();
          }
        });
      });
    }

    // ---------- 🛒 Update cart count on cart:update event ----------
    // This works alongside the shop script that updates [data-cart-count]
    document.addEventListener('cart:update', function (event) {
      if (cartCount) {
        cartCount.textContent = event.detail.item_count;
      }
    });

    // Also update when the page loads (initial count is already set)
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
